import * as React from 'react';
import { UIDataModel } from '../uicomponent';
import { UIComponentViewImpl } from '../uicomponentview';
import { ToggleButtonProps, ToggleButtonState } from './togglebuttoncomponent';
import { ToggleButtonCSSStyle } from './togglebuttoncss';
import './buttonstyle.css';

export class ToggleButtonView extends UIComponentViewImpl<UIDataModel>{

    draw(uiProps: ToggleButtonProps, uiState: ToggleButtonState, cssStyle: ToggleButtonCSSStyle): JSX.Element | boolean{
        super.draw(uiProps, uiState, cssStyle);
        
        return(
           <>
               <div id="toggle-botton-wrapper">
               {
                   this.getWebView(uiProps, uiState, cssStyle)
               }
            </div>
            <div id="toggle-botton-col-wrapper">
                {
                    this.getMobileView(uiProps, uiState, cssStyle)
                }
            </div>
           </>
        );
    }

    getWebView(uiProps: ToggleButtonProps, uiState: ToggleButtonState, cssStyle: ToggleButtonCSSStyle)
    {
        return(
            <button style={uiState.style.getButtonStyle(uiProps.isSelected)} onClick={uiProps.onClick}>
                <label style={uiState.style.getButtonText(uiProps.isSelected)}>{uiState.label}</label><br/>
            </button> 
        );
    }

    getMobileView(uiProps: ToggleButtonProps, uiState: ToggleButtonState, cssStyle: ToggleButtonCSSStyle)
    {
        return(
            <button style={uiState.style.getMobileButtonStyle(uiProps.isSelected)} onClick={uiProps.onClick}>
                <label style={uiState.style.getMobileButtonText(uiProps.isSelected)}>{uiState.label}</label><br/>
            </button> 
        );
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/togglebutton/togglebuttonview.tsx